import * as React from "react";
import * as main from "../../main.module.scss";
import * as steps from "./style.module.scss";
export const Steps = () => {
  return (
    <section className={steps.steps}>
      <div className="container">
        <div className={steps.inner}>
          <h2 className={main.title}>Первая ступень: учимся читать</h2>
          <ul className={steps.first}>
            <li>
              <img src="https://fs.advance.ru/landing-pages/online/uchis_uchitsya_nachalo/first-01.jpg" alt=""/>
              <div className={steps.info}>
                <h3>учим буквы</h3>
                <p>103 урока до&nbsp;10&nbsp;минут</p>
              </div>
            </li>
            <li>
              <img src="https://fs.advance.ru/landing-pages/online/uchis_uchitsya_nachalo/first-02.jpg" alt=""/>
              <div className={steps.info}>
                <h3>Чтение по&nbsp;слогам</h3>
                <p>36 уроков до&nbsp;15&nbsp;минут</p>
              </div>
            </li>
            <li>
              <img src="https://fs.advance.ru/landing-pages/online/uchis_uchitsya_nachalo/first-03.jpg" alt=""/>
              <div className={steps.info}>
                <h3>ЧТЕНИЕ ПО&nbsp;СЛОВАМ</h3>
                <p>20 уроков до&nbsp;20&nbsp;минут</p>
              </div>
            </li>
            <li>
              <img src="https://fs.advance.ru/landing-pages/online/uchis_uchitsya_nachalo/first-04.jpg" alt=""/>
              <div className={steps.info}>
                <h3>СКОРО&shy;ЧТЕНИЕ</h3>
                <p>20 уроков до&nbsp;20&nbsp;минут</p>
              </div>
            </li>
          </ul>
          <h2 className={main.title}>Вторая ступень: проходим предметы</h2>
          <ul className={steps.second}>
            <li>
              <img src="https://fs.advance.ru/landing-pages/online/uchis_uchitsya_nachalo/second-rus.png" alt=""/>
              <h3>Русский язык:</h3>
              <ul className={steps.innerList}>
                <li>запоминание словарных слов;</li>
                <li>падежи;</li>
                <li>морфемный, фонетический и синтаксические разборы;</li>
                <li>основные правила грамматики;</li>
                <li>безударные гласные в корне слова;</li>
                <li>непроизносимые согласные;</li>
                <li>буквосочетания «жи-ши», «ча-ща», «чу-щу»;</li>
                <li>проверяемые согласные в корне слова;</li>
                <li>«не» с глаголами.</li>
              </ul>
            </li>
            <li>
              <img src="https://fs.advance.ru/landing-pages/online/uchis_uchitsya_nachalo/second-math.png" alt=""/>
              <h3>Математика:</h3>
              <ul className={steps.innerList}>
                <li>устный счет в пределах 100;</li>
                <li>таблица умножения;</li>
                <li>задачи простые арифметические операции;</li>
                <li>задачи с геометрическими фигурами;</li>
                <li>простые уравнения.</li>
              </ul>
            </li>
            <li>
              <img src="https://fs.advance.ru/landing-pages/online/uchis_uchitsya_nachalo/second-lit.png" alt=""/>
              <h3>Литература:</h3>
              <ul className={steps.innerList}>
                <li>выделение главного;</li>
                <li>эффективное чтение;</li>
                <li>скорочтение.</li>
              </ul>
            </li>
            <li>
              <img src="https://fs.advance.ru/landing-pages/online/uchis_uchitsya_nachalo/second-mir.png" alt=""/>
              <h3>Окружающий мир:</h3>
              <ul className={steps.innerList}>
                <li>работа с классификациями;</li>
                <li>работа с определениями.</li>
              </ul>
            </li>
          </ul>
          <h2 className={main.title}>Чему научится родитель:</h2>
          <ul className={steps.third}>
            <li>Помогать детям осваивать навыки чтения.</li>
            <li>Выявлять трудности в освоении навыка чтения.</li>
            <li>Отрабатывать выявленные трудности.</li>
            <li>Помогать ребёнку в освоении школьный программы, а не делать домашки за него.</li>
            <li>Помогать ребёнку в развитии памяти, внимания, интеллектуальной выносливости.</li>
            <li>Обучать ребёнка умению классифицировать.</li>
          </ul>
          <a href={"#widget"} className={main.btn}>Записаться на курс</a>
        </div>
      </div>
    </section>
  );
};
